'use client';

import { ComponentProps, ReactNode } from 'react';
import { useFormStatus } from 'react-dom';

import Button from '../button';

interface Props extends Omit<ComponentProps<typeof Button>, 'type'> {
	loadingIcon?: ReactNode;
}

export default function SubmitButton({ loadingIcon, icon, ...props }: Props) {
	const { pending } = useFormStatus();

	return <Button disabled={pending} type="submit" icon={pending ? loadingIcon : icon} {...props} />;
}
